module.exports = __webpack_public_path__ + "img/account-star.a6cb2116.svg";